import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchData } from "../../utils";
import { setNotification } from "../notificationsSlice";
import { has, toLower } from "lodash";
import { API_ORG_DETAILS, API_ORG_LICENSES } from "../../settings";
import { schemas } from '../schemas';


export const getOrgDetails = createAsyncThunk(
    "getOrgDetails",
    async(org, { dispatch, rejectWithValue }) => {
        try {
            const response = await fetchData(API_ORG_DETAILS, {
                headers: { "X-Org-Alias": toLower(org) }
            }, schemas.ORG);
            if (has(response, "entities") && has(response.entities, "organisations")) {
                return response.entities.organisations[toLower(org)];
            };
        } catch (e) {
            dispatch(setNotification(e));
            return rejectWithValue({ code: e.code });
        };
        return rejectWithValue({});
    }
);

export const getOrgLicense = createAsyncThunk(
    "getOrgLicense",
    async(id, { dispatch, rejectWithValue }) => {
        try {
            const response = await fetchData(API_ORG_DETAILS + "/licenses/" + id, {}, {});
            return(response.result);
        } catch (e) {
            dispatch(setNotification(e));
            return rejectWithValue({ code: e.code });
        };
    }
)

export const addOrgLicense = createAsyncThunk(
    "addOrgLicense",
    async({ orgAlias, file, expiryDate, notes }, { dispatch, rejectWithValue }) => {
        try {
            const fmData = new FormData();
            fmData.append("data", JSON.stringify({
                expiry_date: expiryDate,
                notes: notes
            }));

            if (file) {
                fmData.append("file", file);
            };
            const response = await fetchData(API_ORG_LICENSES(orgAlias), {
                method: "POST",
                body: fmData
            }, {});
            dispatch(setNotification(response.result));
            return { entity: "licenses", ...response.result };
        } catch (e) {
            dispatch(setNotification(e));
            return rejectWithValue({ code: e.code });
        };
    }
);

export const editOrgLicense = createAsyncThunk(
    "editOrgLicense",
    async({ id, expiryDate, notes }, { dispatch, rejectWithValue }) => {
        try {
            const response = await fetchData(API_ORG_LICENSES() + "/" + id, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    expiry_date: expiryDate,
                    notes: notes
                })
            }, {});
            dispatch(setNotification(response.result));
            return { entity: "licenses", ...response.result };
        } catch (e) {
            dispatch(setNotification(e));
            return rejectWithValue({ code: e.code });
        };
    }
);

export const deleteOrgLicense = createAsyncThunk(
    "deleteOrgLicense",
    async(id, { dispatch }) => {
        try {
            const response = await fetchData(API_ORG_LICENSES() + "/" + id, {
                method: "DELETE",
            }, {});
            dispatch(setNotification(response.result));
            return {entity: "licenses", ...response.result};
        } catch (e) {
            dispatch(setNotification(e));
            return false;
        };
    }
);

export const downloadOrgLicense = createAsyncThunk(
    "downloadOrgLicense",
    async(id, { dispatch }) => {
        try {
            const response = await fetchData(API_ORG_LICENSES() + "/" + id + "/download", {}, {});
            let a = document.createElement("a");
            a.download = response.result.saveAs;
            a.href = response.result.url;
            a.rel = "noopener noreferrer";
            a.target = "_blank";
            a.click();
            a.remove();
        } catch (e) {
            dispatch(setNotification(e));
        };
    }
);

export const deleteOrg = createAsyncThunk(
    "deleteOrg",
    async(org, { dispatch, rejectWithValue }) => {
        try {
            const response = await fetchData(API_ORG_DETAILS, {
                method: "DELETE",
                headers: { "X-Org-Alias": toLower(org) }
            }, {});
            dispatch(setNotification(response.result));
            return response.result;
        } catch (e) {
            dispatch(setNotification(e));
            return rejectWithValue();
        };
    }
);
